

























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import * as rules from '@/modules/shared/shared/domain/rules';
import { infodaycoUpload } from '@/modules/infodayco/shared/store/namespaces';
import { InfodaycoUploadActions } from '@/modules/infodayco/upload/store/infodayco-upload.actions';
import { FileCreationRequest } from '@/modules/infodayco/shared/domain/file-creation.request';
import { VideoTutorial } from '@/modules/infodayco/shared/domain/video-tutorial';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    name: 'infodayco-upload',
    components: { BaseModal, SectionTitle },
})
export default class InfodaycoUpload extends Vue {
    private isLoading: boolean = false;

    private formAttributes = {
        file: null,
        name: '',
        url: '',
    };

    private rules: any = rules;

    private getVideoId(url: string) {
        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        if (match) {
            return match[2];
        }
        return undefined;
    }

    private validYouTubeUrl() {
        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

        return v =>
            (v && v.match(regExp)) ||
            'URL incorrecto. Debe ser un enlace de YouTube para compartir.';
    }

    $refs!: {
        form: any;
        modal: any;
    };

    private documentTypes = [
        {
            name: 'Modelo de servicio',
            type: 1,
        },
        {
            name: 'Tutorial',
            type: 2,
        },
        {
            name: 'Vídeo',
            type: 3,
        },
    ];

    selectedType: number | null = null;

    async mounted() {
        this.changeTitle({
            title: 'GESTIÓN',
            route: ['MIS GUÍAS Y TUTORIALES'],
        });
    }

    onFileChange(e) {
        if (e === null) {
            this.formAttributes.file = null;
        } else {
            this.formAttributes.file = e;
        }
    }

    async executeRequest() {
        this.isLoading = true;
        if (this.$refs.form.validate()) {
            const typesFunctions = {
                1: this.uploadGuide,
                2: this.uploadTutorial,
                3: this.uploadVideoTutorial,
            };
            let request = {};
            if (this.selectedType! < 3) {
                request = {
                    name: this.formAttributes.name,
                    file: this.formAttributes.file,
                };
            } else {
                const videoId = this.getVideoId(this.formAttributes.url);
                request = {
                    name: this.formAttributes.name,
                    url: 'https://www.youtube.com/embed/' + videoId,
                };
            }
            const failed = await typesFunctions[this.selectedType!](request);
            if (failed) {
                failed.showError();
            } else {
                this.$refs.form.reset();
            }
        }
        this.isLoading = false;

        this.$refs.modal.closeModal();
    }

    @infodaycoUpload.Action(InfodaycoUploadActions.UPLOAD_GUIDE)
    uploadGuide!: (guide: FileCreationRequest) => Promise<RequestResponse>;

    @infodaycoUpload.Action(InfodaycoUploadActions.UPLOAD_TUTORIAL)
    uploadTutorial!: (tutorial: FileCreationRequest) => Promise<RequestResponse>;

    @infodaycoUpload.Action(InfodaycoUploadActions.UPLOAD_VIDEO_TUTORIAL)
    uploadVideoTutorial!: (video: Partial<VideoTutorial>) => Promise<RequestResponse>;

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;
}
